import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import SaveIcon from "@mui/icons-material/Save";
import { Menu } from 'primereact/menu';
import { useRef } from 'react';


const apiUrl = process.env.REACT_APP_API_URL;

export default function DevisDialog({ visible, onHide, leadData, onDevisGenerated ,forceNew = false}) {
  const [formule, setFormule] = useState("avec_alcool");
  const [prixParPersonne, setPrixParPersonne] = useState(20);
  const [remise, setRemise] = useState(0);
  const [generating, setGenerating] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [devisInfo, setDevisInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [nbPersonnes, setNbPersonnes] = useState(leadData?.nbpers || 0);
  const [nbBarmen, setNbBarmen] = useState(1);
  const [structure, setStructure] = useState("tuk_tuk");
  const [options, setOptions] = useState([]);

const menuRef = useRef(null);

  // Calculs
  const sousTotalPrestation = nbPersonnes * prixParPersonne;
  const sousTotalOptions = options.reduce((sum, opt) => sum + (opt.prix || 0), 0);
  const sousTotal = sousTotalPrestation + sousTotalOptions;
  const montantRemise = (sousTotal * remise) / 100;
  const total = sousTotal - montantRemise;

  

const [editModeClient, setEditModeClient] = useState(false);
const [hasChanges, setHasChanges] = useState(false);

const [tempNom, setTempNom] = useState(leadData?.nomPrenom || "");
const [tempEmail, setTempEmail] = useState(leadData?.email || "");
const [tempTel, setTempTel] = useState(leadData?.tel || "");
const [tempLieu, setTempLieu] = useState(leadData?.lieu || "");
const [tempNbpers, setTempNbpers] = useState(leadData?.nbpers || "");
const [tempDateEvent, setTempDateEvent] = useState(leadData?.dateEvent || "");
const [tempTypeBar, setTempTypeBar] = useState(leadData?.type_bar || "");
const [tempMore, setTempMore] = useState(leadData?.plusInfos || "");


const [etatSouhaite, setEtatSouhaite] = useState("");


useEffect(() => {
  if (leadData) {
    const hasAnyChange = 
      tempNom !== (leadData.nomPrenom || "") ||
      tempEmail !== (leadData.email || "") ||
      tempTel !== (leadData.tel || "") ||
      tempLieu !== (leadData.lieu || "") ||
      tempNbpers !== (leadData.nbpers || "") ||
      tempDateEvent !== (leadData.dateEvent || "") ||
      tempTypeBar !== (leadData.type_bar || "") ||
      tempMore !== (leadData.plusInfos || "");
    
    setHasChanges(hasAnyChange);
  }
}, [tempNom, tempEmail, tempTel, tempLieu, tempNbpers, tempDateEvent, tempTypeBar, tempMore, leadData]);

useEffect(() => {
  if (leadData) {
    setTempNom(leadData.nomPrenom || "");
    setTempEmail(leadData.email || "");
    setTempTel(leadData.tel || "");
    setTempLieu(leadData.lieu || "");
    setTempNbpers(leadData.nbpers || "");
    setTempDateEvent(leadData.dateEvent || "");
    setTempTypeBar(leadData.type_bar || "");
    setTempMore(leadData.plusInfos || "");
    setHasChanges(false);
  }
}, [leadData]);


const handleSaveClient = async () => {
  try {
    await axios.post(`${apiUrl}/IHM/api/update_ficheLead.php`, {
      idLead: leadData.idLead,
      nom: tempNom,
      telephone: tempTel,
      email: tempEmail,
      lieu: tempLieu,
      nbpers: tempNbpers,
      typeBar: tempTypeBar,
      more: tempMore,
      dateEvent: tempDateEvent,
      adminMod: localStorage.getItem("us"),
    });
    
    setHasChanges(false);
    setSnackbarMessage("Informations client mises à jour");
    setOpenSnackbar(true);
    
    if (onDevisGenerated) onDevisGenerated();
    
  } catch (error) {
    console.error("Erreur de mise à jour :", error);
    setSnackbarMessage("Erreur lors de la sauvegarde");
    setOpenSnackbar(true);
  }
};

  useEffect(() => {
    if (leadData?.nbpers) setNbPersonnes(leadData.nbpers);
  }, [leadData]);

  // useEffect(() => {
  //   if (visible && leadData?.idLead) checkExistingDevis();
  // }, [visible, leadData]);

  useEffect(() => {
  if (visible && leadData?.idLead && !forceNew) {
    checkExistingDevis();
  } else if (visible && forceNew) {
    setDevisInfo(null);
    setLoading(false);
  }
}, [visible, leadData, forceNew]);

useEffect(() => {
  if (forceNew) {
    resetForm();
  }
}, [forceNew]);

  
const checkExistingDevis = async () => {
  setLoading(true);
  setDevisInfo(null);

if (forceNew) {
  setLoading(false);
  return;
}

  try {
    const response = await axios.get(`${apiUrl}/IHM/api/generer_devis.php?lead_id=${leadData.idLead}`);
    if (response.data.a_devis == 1) {  
      setDevisInfo({
        a_devis: response.data.a_devis,
        numero_devis: response.data.dernier_devis_id,
        lien_devis: response.data.lien_devis,
        lien_pdf: response.data.lien_pdf,
        token_devis: response.data.token_devis,
        montant_devis: response.data.montant_total || 0,
        date_devis: response.data.date_devis || new Date().toISOString(),
        idVosFactures: response.data.idVosFactures,
        statut_devis: response.data.statut_devis || "brouillon",

        
      });
    } else {
      setDevisInfo(null);
    }
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

  const handleCloseSnackbar = () => setOpenSnackbar(false);

  const ajouterOption = () => {
    setOptions([...options, { titre: "", description: "", prix: 0 }]);
  };

  const supprimerOption = (index) => {
    const newOptions = [...options];
    newOptions.splice(index, 1);
    setOptions(newOptions);
  };

  const modifierOption = (index, champ, valeur) => {
    const newOptions = [...options];
    newOptions[index][champ] = valeur;
    setOptions(newOptions);
  };

  const handleGenererDevis = async () => {
    if (!leadData) return;
    setGenerating(true);
    try {
      const response = await axios.post(`${apiUrl}/IHM/api/generer_devis.php`, {
        lead_id: leadData.idLead,
        nom: leadData.nomPrenom,
        email: leadData.email,
        tel: leadData.tel,
        lieu: leadData.lieu,
        nb_personnes: nbPersonnes,
        nb_barmen: nbBarmen,
        formule: formule,
        prix_par_personne: prixParPersonne,
        remise: remise,
        structure: structure,
        options: options,
        is_new_version: forceNew,
        adminMod: localStorage.getItem("us"),
      });
      
      if (response.data.success) {
        setDevisInfo({
          a_devis: 1,
          lien_devis: response.data.devis_url,
          lien_pdf: response.data.pdf_url,
          numero_devis: response.data.devis_number,
          montant_devis: response.data.montant
        });
        // checkExistingDevis();
        
        setSnackbarMessage("Devis généré avec succès !");
        setOpenSnackbar(true);
        if (onDevisGenerated) onDevisGenerated();

        // setTimeout(() => {
        //   onHide();
        //   resetForm();
        // }, 2000);

      } else {
        setSnackbarMessage(response.data.message || "Erreur");
        setOpenSnackbar(true);
      }
    } catch (error) {
      setSnackbarMessage("Erreur lors de la génération");
      setOpenSnackbar(true);
    } finally {
      setGenerating(false);
    }
  };

  const resetForm = () => {
    setFormule("avec_alcool");
    setPrixParPersonne(20);
    setRemise(0);
    setNbPersonnes(leadData?.nbpers || 0);
    setNbBarmen(1);
    setStructure("tuk_tuk");
    setOptions([]);
  };

  // Styles pour supprimer le ring bleu
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .p-inputtext:enabled:focus, .p-inputtext:focus {
        box-shadow: none !important;
        outline: none !important;
        border-color: #ced4da !important;
      }
      input:focus {
        outline: none !important;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);


const handleEtatChange = async (newEtat) => {
  if (!newEtat) return;

  try {
    const data = {
      idLead: leadData.idLead,
      etat: newEtat,
      note: '',
      adminMod: localStorage.getItem("us"),
    };

    const response = await axios.put(`${apiUrl}/IHM/api/lead.php`, data);
    if (response.data) {
      setSnackbarMessage(`État changé avec succès`);
      setOpenSnackbar(true);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  } catch (error) {
    console.error("Erreur:", error);
    setSnackbarMessage("Erreur lors du changement d'état");
    setOpenSnackbar(true);
  }
};

const menuItems = [
  { label: 'En cours', command: () => handleEtatChange('1') },
  { label: 'Relance', command: () => handleEtatChange('2') },
  { label: 'Suivis', command: () => handleEtatChange('6') },
  { label: 'Validés', command: () => handleEtatChange('3') },
  { label: 'Réalisés', command: () => handleEtatChange('4') },
  { label: 'Abandons', command: () => handleEtatChange('5') }
];
 const header = (
    <div className="flex justify-content-between align-items-center w-full">
      <span className="font-semibold text-lg">
        Fiche client & devis
      </span>

     <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
  <Button
  icon="pi pi-sync"
  text
  rounded
  size="small"
  onClick={(e) => menuRef.current?.toggle(e)}
  tooltipOptions={{ position: "bottom" }}
  className="p-button-text no-focus-outline"
  style={{ 
    width: "32px", 
    height: "32px",
    background: "#f9fafb",
    color: "#4b5563"
  }}
/>
  <Menu model={menuItems} popup ref={menuRef} />
</div>
    </div>
  );
  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
        action={
          <IconButton
            size="small"
            color="inherit"
            onClick={handleCloseSnackbar}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />

      <Dialog
        blockScroll
        visible={visible}
        header={header}
        className="custom-dialog"
        style={{ width: "45vw", maxWidth: "700px" }}
        modal
        onHide={() => {
          onHide();
          resetForm();
        }}
        breakpoints={{ "960px": "90vw", "640px": "95vw" }}
      >

        
        <div className="p-3">
      

          {/* Section 1 */}
        <div className="grid">
  <div className="col-12">
    <div style={{ 
      background: "#f3f4f6", 
      padding: "4px 8px", 
      borderRadius: "4px", 
      marginBottom: "10px", 
      display: "flex", 
      alignItems: "center", 
      justifyContent: "space-between"  
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <span style={{ 
          background: "#374151", 
          color: "white", 
          borderRadius: "50%", 
          width: "18px", 
          height: "18px", 
          display: "inline-flex", 
          alignItems: "center", 
          justifyContent: "center", 
          fontSize: "11px", 
          fontWeight: 700 
        }}>1</span>
        <span style={{ 
          fontSize: "11px", 
          fontWeight: 600, 
          color: "#374151", 
          letterSpacing: "0.05em" 
        }}>INFORMATIONS CLIENT</span>
      </div>
      
      {hasChanges && (
        <span
          onClick={() => handleSaveClient()}
          style={{
            border: "1px solid #22c55e",
            borderRadius: "50%",
            color: "#fff",
            width: "28px",
            height: "28px",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            transition: "all 0.2s ease",
            backgroundColor: "#22c55e",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#22c55e";
            e.currentTarget.style.color = "#fff";
          }}
        >
          <SaveIcon sx={{ fontSize: 16 }} />
        </span>
      )}
    </div>
  </div>
</div>

        <div className="grid">
          <div className="col-12 md:col-4">
            <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>Nom</label>
            <input value={tempNom} onChange={(e) => setTempNom(e.target.value)} style={{ width: "100%", height: "36px", padding: "0 8px", border: "1px solid #d1d5db", borderRadius: "5px", background: "white", fontSize: "14px" }} />
          </div>
          <div className="col-12 md:col-4">
            <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>Email</label>
            <input value={tempEmail}  onChange={(e) => setTempEmail(e.target.value)} style={{ width: "100%", height: "36px", padding: "0 8px", border: "1px solid #d1d5db", borderRadius: "5px", background: "white", fontSize: "14px" }} />
          </div>
          <div className="col-12 md:col-4">
            <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>Téléphone</label>
            <input   value={tempTel} onChange={(e) => setTempTel(e.target.value)} style={{ width: "100%", height: "36px", padding: "0 8px", border: "1px solid #d1d5db", borderRadius: "5px", background: "white", fontSize: "14px" }} />
          </div>
        </div>

<div className="grid">
  <div className="col-12 md:col-3">
    <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>Nb pers</label>
    <input type="number" value={tempNbpers} 
      onChange={(e) => setTempNbpers(e.target.value)}
      style={{ width: "100%", height: "36px", padding: "0 8px", border: "1px solid #d1d5db", borderRadius: "5px", fontSize: "14px" }}  />
  </div>
  <div className="col-12 md:col-3">
    <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>Lieu</label>
    <input value={tempLieu} 
      onChange={(e) => setTempLieu(e.target.value)}
      style={{ width: "100%", height: "36px", padding: "0 8px", border: "1px solid #d1d5db", borderRadius: "5px", fontSize: "14px" }}  />
  </div>
  <div className="col-12 md:col-3">
    <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>Date évènement</label>
    <input type="date"  value={tempDateEvent} 
      onChange={(e) => setTempDateEvent(e.target.value)}
      style={{ width: "100%", height: "36px", padding: "0 8px", border: "1px solid #d1d5db", borderRadius: "5px", fontSize: "14px", background: "white" }} />
  </div>
  <div className="col-12 md:col-3">
  <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>Type de bar</label>
  <select 
      value={tempTypeBar} 
      onChange={(e) => setTempTypeBar(e.target.value)}
      style={{ 
        width: "100%", 
        height: "36px", 
        padding: "0 8px", 
        border: "1px solid #d1d5db", 
        borderRadius: "5px", 
        fontSize: "14px", 
        background: "white" 
      }}
    >
      <option value="avec_alcool">Avec alcool</option>
      <option value="sans_alcool">Sans alcool</option>
      <option value="avec_alcool, sans_alcool">Avec et sans alcool</option>
    </select>
</div>
</div>

<div className="grid">
  <div className="col-12">
    <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>Plus d'infos</label>
    <textarea value={tempMore} onChange={(e) => setTempMore(e.target.value)}
 rows={3} 
      style={{ width: "100%", padding: "8px", border: "1px solid #d1d5db", borderRadius: "5px", fontSize: "14px", resize: "vertical" }} />
  </div>
</div>


          {loading ? (
            <div className="flex justify-content-center p-5">
              <i
                className="pi pi-spin pi-spinner"
                style={{ fontSize: "2rem", color: "#2563eb" }}
              ></i>
            </div>
          ) : (!devisInfo?.a_devis || forceNew) ? (
            <>

<div className="grid">

  <div className="col-12">
<div style={{ background: "#f3f4f6", padding: "4px 8px", borderRadius: "4px", marginBottom: "10px", display: "flex", alignItems: "center", gap: "6px" }}>
          <span style={{ background: "#374151", color: "white", borderRadius: "50%", width: "18px", height: "18px", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: 700 }}>2</span>
          <span style={{ fontSize: "11px", fontWeight: 600, color: "#374151", letterSpacing: "0.05em" }}>GENERER LE DEVIS</span>
        </div>
        </div>
</div>


             



<div className="grid">
  <div className="col-12">
<div style={{ display: "flex", gap: "8px", alignItems: "flex-end", flexWrap: "wrap", width: "100%",justifyContent: "space-between" }}>
  <div style={{ flex: "0 0 auto" }}>
    <label style={{ fontSize: "11px", color: "#374151", display: "block", marginBottom: "2px" }}>Nb pers</label>
    <input type="number" value={nbPersonnes} onChange={(e) => setNbPersonnes(parseInt(e.target.value) || 0)} min={1} style={{ width: "65px", height: "35px", padding: "0 6px", border: "1px solid #d1d5db", borderRadius: "5px", fontSize: "14px" }} />
  </div>
  <div style={{ flex: "0 0 auto" }}>
    <label style={{ fontSize: "11px", color: "#374151", display: "block", marginBottom: "2px" }}>Barmans</label>
    <input type="number" value={nbBarmen} onChange={(e) => setNbBarmen(parseInt(e.target.value) || 1)} min={1} style={{ width: "65px", height: "35px", padding: "0 6px", border: "1px solid #d1d5db", borderRadius: "5px", fontSize: "14px" }} />
  </div>
  <div style={{ flex: "0 0 auto" }}>
    <label style={{ fontSize: "11px", color: "#374151", display: "block", marginBottom: "2px" }}>Structure</label>
    <select value={structure} onChange={(e) => setStructure(e.target.value)} style={{ height: "35px", padding: "0 6px", border: "1px solid #d1d5db", borderRadius: "5px", fontSize: "13px", background: "white" }}>
      <option value="tuk_tuk">Le Tuk-Tuk</option>
      <option value="elegance">Le Bar Élégance</option>
      <option value="both">Les deux</option>
    </select>
  </div>
  <div style={{ flex: "0 0 auto" }}>
    <label style={{ fontSize: "11px", color: "#374151", display: "block", marginBottom: "2px" }}>Formule</label>
    <select value={formule} onChange={(e) => setFormule(e.target.value)} style={{ height: "35px", padding: "0 6px", border: "1px solid #d1d5db", borderRadius: "5px", fontSize: "13px", background: "white" }}>
      <option value="avec_alcool">Avec alcool</option>
      <option value="sans_alcool">Sans alcool</option>
    </select>
  </div>
  <div style={{ flex: "0 0 auto" }}>
    <label style={{ fontSize: "11px", color: "#374151", display: "block", marginBottom: "2px" }}>Prix/pers €</label>
    <input type="number" value={prixParPersonne} onChange={(e) => setPrixParPersonne(parseFloat(e.target.value) || 0)} min={0} style={{ width: "70px", height: "35px", padding: "0 6px", border: "1px solid #d1d5db", borderRadius: "5px", fontSize: "14px" }} />
  </div>
  <div style={{ flex: "0 0 auto" }}>
    <label style={{ fontSize: "11px", color: "#374151", display: "block", marginBottom: "2px" }}>Remise %</label>
    <input type="number" value={remise} onChange={(e) => setRemise(parseFloat(e.target.value) || 0)} min={0} max={100} style={{ width: "65px", height: "35px", padding: "0 6px", border: "1px solid #d1d5db", borderRadius: "5px", fontSize: "14px" }} />
  </div>
  <div style={{ flex: "0 0 auto" }}>
    <label style={{ fontSize: "11px", color: "#374151", display: "block", marginBottom: "2px" }}>Option</label>
    <button onClick={ajouterOption} style={{ width: "35px", height: "35px", border: "1px solid #d1d5db", borderRadius: "5px", background: "white", fontSize: "20px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>+</button>
  </div>
</div>
</div>
</div>


          


<div className="grid">
  <div className="col-12">
              {options.map((option, index) => (
  <div key={index} style={{ display: "flex", gap: "8px", alignItems: "flex-end", marginTop: "8px" }}>
    <div style={{ flex: 2 }}>
      <label style={{ fontSize: "11px", color: "#374151", display: "block", marginBottom: "2px" }}>Titre</label>
      <input value={option.titre} onChange={(e) => modifierOption(index, "titre", e.target.value)}
        placeholder="Titre"
        style={{ width: "100%", height: "35px", padding: "0 8px", border: "1px solid #d1d5db", borderRadius: "5px", fontSize: "14px" }} />
    </div>
    <div style={{ flex: 2 }}>
      <label style={{ fontSize: "11px", color: "#374151", display: "block", marginBottom: "2px" }}>Description</label>
      <input value={option.description} onChange={(e) => modifierOption(index, "description", e.target.value)}
        placeholder="Description"
        style={{ width: "100%", height: "35px", padding: "0 8px", border: "1px solid #d1d5db", borderRadius: "5px", fontSize: "14px" }} />
    </div>
    <div style={{ width: "80px" }}>
      <label style={{ fontSize: "11px", color: "#374151", display: "block", marginBottom: "2px" }}>Prix €</label>
      <input type="number" value={option.prix} onChange={(e) => modifierOption(index, "prix", parseFloat(e.target.value) || 0)}
        placeholder="0" min={0} step={1}
        style={{ width: "100%", height: "35px", padding: "0 8px", border: "1px solid #d1d5db", borderRadius: "5px", fontSize: "14px" }} />
    </div>
    <div>
      <button onClick={() => supprimerOption(index)}
        style={{ height: "35px", width: "35px", border: "1px solid #fca5a5", borderRadius: "5px", background: "white", color: "#ef4444", cursor: "pointer", fontSize: "16px" }}>
        ✕
      </button>
    </div>
  </div>
))}
</div>
</div>
              

<div className="grid">
  <div className="col-12">
    <div style={{ background: "#f5f3eb", borderRadius: "5px", padding: "8px 12px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "14px" }}>
        <span>Prestation ({nbPersonnes} x {prixParPersonne}€)</span>
        <span>{sousTotalPrestation.toFixed(2)} €</span>
      </div>
      {options.map((opt, idx) => (
        <div key={idx} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "14px" }}>
          <span>{opt.titre || "Option"}</span>
          <span>{opt.prix.toFixed(2)} €</span>
        </div>
      ))}
      <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderTop: "1px solid #d1d5db", marginTop: "4px", fontWeight: 600, fontSize: "14px" }}>
        <span>Sous-total</span>
        <span>{sousTotal.toFixed(2)} €</span>
      </div>
      {remise > 0 && (
        <div style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "14px", color: "#ef4444" }}>
          <span>Remise ({remise}%)</span>
          <span>- {montantRemise.toFixed(2)} €</span>
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderTop: "1px solid #d1d5db", marginTop: "4px", fontWeight: 700, fontSize: "15px" }}>
        <span>Total TTC</span>
        <span>{total.toFixed(2)} €</span>
      </div>
    </div>
  </div>
</div>

<div className="grid">
  <div className="col-12">
    <Button
      label={generating ? "Génération..." : "Générer le devis"}
      icon={generating ? "pi pi-spin pi-spinner" : "pi pi-file"}
      className="w-full"
      style={{
        background: "#dbeafe",
        border: "1px solid #bfdbfe",
        padding: "0.75rem",
        borderRadius: "6px",
        fontSize: "14px",
        fontWeight: 500,
        justifyContent: "center",
        gap: "8px",
        color: "#1d4ed8",
      }}
      onClick={handleGenererDevis}
      disabled={generating || nbPersonnes === 0}
    />
  </div>
</div>


          
            </>
          ) : (
            <>
              <div className="grid">
                <div className="col-12">
                  <div
                    className="p-3 border-round-sm"
                    style={{ background: "#f9fafb", borderRadius: "5px" }}
                  >
                    <div className="flex justify-content-between align-items-center mb-2">
                      <span className="font-bold">Devis N° :</span>
                      <span>{devisInfo.numero_devis}</span>
                    </div>
                    <div className="flex justify-content-between align-items-center mb-2">
                      <span className="font-bold">Date de création :</span>
                      <span>
                        {new Date(devisInfo.date_devis).toLocaleDateString(
                          "fr-FR",
                        )}
                      </span>
                    </div>
                    <div className="flex justify-content-between align-items-center mb-2">
                      <span className="font-bold">Montant total :</span>
                      <span>
                        {parseFloat(devisInfo.montant_devis).toFixed(2)} €
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            
<div className="grid mt-3">
  <div className="col-12">
    <div className="flex gap-2 justify-content-center flex-wrap">
      {devisInfo.lien_pdf && (
        <Button
          label="PDF"
          severity="danger"
          icon="pi pi-download"
          style={{
            background: "#fecaca",
            border: "1px solid #fca5a5",
            padding: "0.75rem",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: 500,
            justifyContent: "center",
            gap: "8px",
            color: "#dc2626",
          }}
          onClick={() => window.open(devisInfo.lien_pdf, "_blank")}
        />
      )}
      {devisInfo.lien_devis && (
        <Button
          label="Voir"
          icon="pi pi-eye"
          severity="info"
          style={{
            background: "#dbeafe",
            border: "1px solid #bfdbfe",
            padding: "0.75rem",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: 500,
            justifyContent: "center",
            gap: "8px",
            color: "#1d4ed8",
          }}
          onClick={() => window.open(devisInfo.lien_devis, "_blank")}
        />
      )}
      <Button
        label="Modifier"
        severity="warning"
        icon="pi pi-pencil"
        style={{
          background: "#fed7aa",
          border: "1px solid #fdba74",
          padding: "0.75rem",
          borderRadius: "6px",
          fontSize: "14px",
          fontWeight: 500,
          justifyContent: "center",
          gap: "8px",
          color: "#c2410c",
        }}
        onClick={() =>
          window.open(
            `https://unptittukenplus.vosfactures.fr/invoices/${devisInfo.idVosFactures}/edit`,
            "_blank"
          )
        }
      />
      <Button
        label="Envoyer le devis"
        icon="pi pi-envelope"
        severity="success"
        style={{
          background: "#dcfce7",
          border: "1px solid #bbf7d0",
          padding: "0.75rem",
          borderRadius: "6px",
          fontSize: "14px",
          fontWeight: 500,
          justifyContent: "center",
          gap: "8px",
          color: "#16a34a",
        }}
        onClick={() => {
          axios
            .post(`${apiUrl}/IHM/api/sendMailDevis.php`, {
              id: leadData.idLead,
              adminMod: localStorage.getItem("us"),
            })
            .then((res) => {
              if (res.data.success) {
                setSnackbarMessage(
                  `Le devis a bien été envoyé à ${leadData.email}`
                );
                setOpenSnackbar(false);

                setDevisInfo({
                  ...devisInfo,
                  statut_devis: "envoye",
                });
                window.location.reload();
              } else {
                setSnackbarMessage(res.data.message || "Envoi impossible");
                setOpenSnackbar(true);
              }
            })
            .catch((err) => {
              console.error("Erreur envoi mail:", err);
              setSnackbarMessage("Impossible d'envoyer le mail");
              setOpenSnackbar(true);
            });
        }}
      />
    </div>
  </div>
</div>


            </>
          )}
        </div>
      </Dialog>
    </>
  );
}